import * as React from 'react'
import { Grid, FormControlLabel, Box } from '@material-ui/core'
import { CellInfo, SortingRule } from 'react-table'
import { t } from 'ttag'
import { formatNullValues } from '../../common/helpers/activitiesHelpers'
import { getCompanyRankingPercentageComparator } from '../../common/helpers/comparators'
import { Card } from '../../components/Card/Card'
import { ProgressCell } from '../../components/Table/components/ProgressCell/ProgressCell'
import { ReactComponent as InfoIcon } from '../../assets/v2/icons/icon-info-gray.svg'
import { Table } from '../../components/Table/Table'
import {
  CompanyId,
  CompanyRankDto,
  GetCompanyRankingFiltered$Request,
  Lang,
  Role,
  ToggleCompanyExcludedFromRanking$Request,
  UserCompanyDto,
} from '../../services/api.types'
import './CompanyRanking.scss'

import { currentLang, isRtl } from '../../i18nInit'
import dayjs from '../../dayjsConfig'
import BlueTooltip from '../../components/YumBlueTooltip/YumBlueTooltip'
import { yuMuuvPublicCompanyId } from '../Settings/Settings'
import YumSwitch from '../../components/YumSwitch/YumSwitch'
import { openActivityIndexArticle } from '../../common/helpers/routeHelpers'

export interface IStateProps {
  companyId: CompanyId
  month: string
  authenticated: boolean
  //userCompanies: UserCompanyDto[]
  periodPercentage: number
  companyIsExcludedFromRanking: boolean
  companyRanking: CompanyRankDto[]
  companyRankingLoading: boolean
  selectedCompanyId: CompanyId | null
  hasRoleInCompany(companyId: CompanyId, role: Role): boolean
}

export interface IDispatchProps {
  getCompanyRankingAction(request: GetCompanyRankingFiltered$Request): void
  toggleCompanyExcludedFromRanking(
    request: [ToggleCompanyExcludedFromRanking$Request, GetCompanyRankingFiltered$Request],
  ): void
  setSelectedCompanyId(payload: CompanyId): void
}

type IActivityProps = IStateProps & IDispatchProps

/*const selectUserCompany = (userCompanies: UserCompanyDto[], selectedCompanyId: CompanyId | null): UserCompanyDto => {
  const companies = userCompanies.filter((uc) => !uc.hideRankingView)
  if (selectedCompanyId) {
    const uc = companies.find((uc) => uc.companyId === selectedCompanyId)
    return uc ? uc : companies[0]
  }
  return companies[0]
}*/

export class CompanyRanking extends React.PureComponent<IActivityProps> {
  /*getMonthsList() {
    let dateStart = dayjs('2020-03-01')
    let dateEnd = dayjs()
    if (currentLang === Lang.EN) {
      dateStart = dateStart.locale('en')
      dateEnd = dateEnd.locale('en')
    }
    const interim = dateStart.clone()
    const timeValues: any = []

    while (dateEnd > interim || interim.format('M') === dateEnd.format('M')) {
      const interimLocalized = interim.clone().locale('en')
      timeValues.push({
        value: interimLocalized.format('YYYY-MM'),
        label: interim.format('MMM YYYY').replace(/^\w/, (c) => c.toUpperCase()),
      })
      interim.add(1, 'month')
    }

    return timeValues.reverse()
  }*/

  state = {
    isTotalProjectedPercentageVisible: true,
    //month: dayjs().locale('en').format('YYYY-MM'),
    //monthsList: this.getMonthsList(),
    //userCompany: selectUserCompany(this.props.userCompanies, this.props.selectedCompanyId),
  }

  componentDidMount(): void {
    //this.loadCompanyRanking()
    const { getCompanyRankingAction, companyId, month } = this.props
    getCompanyRankingAction({ companyId, month })
  }

  loadCompanyRanking(): void {
    const { getCompanyRankingAction, companyId, month } = this.props
    //const { userCompany, month } = this.state
    //const companyId = userCompany?.companyId
    getCompanyRankingAction({ companyId, month })
  }

  async UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (nextProps.companyId !== this.props.companyId || nextProps.month !== this.props.month) {
      this.props.getCompanyRankingAction({ companyId: nextProps.companyId, month: nextProps.month })
    }
  }

  toggleCompanyExcludedFromRanking = (companyId: CompanyId) => () =>
    this.props.toggleCompanyExcludedFromRanking([{ companyId }, { companyId, month: this.props.month }])

  /*handleMonthChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const month = event.target.value as string
    this.setState({ month }, () => this.loadCompanyRanking())
  }*/

  /*findYourself = () => {
    const { userCompany } = this.state
    const companyId = userCompany?.companyId
    const element = document.getElementById(companyId)

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
    }
  }*/

  handleSortedChange = (newSorted: SortingRule[]) => {
    const { id, desc } = newSorted[0]

    const isSortedByPercentageDesc = id === 'percentage' && desc
    const isSortedByRankAsc = id === 'rank' && !desc

    this.setState({ isTotalProjectedPercentageVisible: isSortedByPercentageDesc || isSortedByRankAsc })
  }

  getTableData = (companyId: CompanyId, companyRanking: CompanyRankDto[]) => {
    let prevRank = 0
    let prevTotal = -1
    const companyRankingSorted = Object.entries(companyRanking || {}).sort(getCompanyRankingPercentageComparator) || []
    const data = companyRankingSorted
      .map((i, index) => {
        if (!i || !i[1]) {
          return null
        }

        const {
          companyId: compareId,
          companyName,
          //participants,
          percentage,
          //rank,
        } = i[1]

        const isCompleted = percentage >= 100
        const isSelf = companyId === compareId
        const nextTotal = formatNullValues(percentage)
        const sameRankAsPrev = nextTotal === prevTotal
        const rank = sameRankAsPrev ? prevRank : index + 1
        prevTotal = nextTotal
        prevRank = rank

        /*const prevCompany = companyRankingSorted.map((company) => company[1])[index - 1] || { percentage: undefined }
        const nextCompany = companyRankingSorted.map((company) => company[1])[index + 1] || { percentage: undefined }

        const isSeparatorForAbove = isTotalProjectedPercentageVisible && percentage < periodPercentage && prevCompany.percentage === undefined

        const isSeparatorForBelow =
          isTotalProjectedPercentageVisible &&
          percentage >= periodPercentage &&
          nextCompany.percentage < periodPercentage*/

        return {
          ...i[1],
          companyName,
          isCompleted,
          isSelf,
          //isSeparatorForBelow,
          //isSeparatorForAbove,
          rank,
        }
      })
      .filter(Boolean)

    // We need the isBeforeSelf flag to prevent table line in the previous row.
    if (data.length) {
      data.some((element, index, array) => {
        if (element && element.isSelf && index > 0) {
          // @ts-ignore
          array[index - 1].isBeforeSelf = true
          return true
        }
        return false
      })
    }

    return data
  }

  /*handleCompanyChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const { userCompanies } = this.props
    const { value } = event.target as { value: CompanyId }
    this.setState({ userCompany: userCompanies.find((company) => company.companyId === value) }, () =>
      this.loadCompanyRanking(),
    )
    this.props.setSelectedCompanyId(value)
  }*/

  render() {
    //const { isTotalProjectedPercentageVisible } = this.state
    //const { month, userCompany } = this.state
    //const companyId = userCompany?.companyId
    const { hasRoleInCompany, companyId, month, companyRanking, companyRankingLoading /*, periodPercentage*/ } =
      this.props

    if (!companyId) {
      return (
        <Card>
          <h1 style={{ marginBottom: '16px' }}>{t`TOP 100`}</h1>
          Currently disabled for your company.
        </Card>
      )
    }

    //const nonPublicCompanies = userCompanies.filter(({ companyId }) => companyId !== yuMuuvPublicCompanyId)
    //const userCompaniesWithRanking = nonPublicCompanies.filter(({ hideRankingView }) => !hideRankingView)

    const data = this.getTableData(companyId, companyRanking)

    const anon = <i>{t`Anonymized`}</i>

    const columns = [
      {
        className: Table.rankBEM(data.length),
        headerClassName: Table.rankBEM(data.length),
        Cell: ({ original: { rank } }: CellInfo) => <span>{rank + '.'}</span>,
        accessor: 'rank',
        // Visually-hidden header so the rank column isn't an empty columnheader
        // for screen readers (WCAG 1.3.1), without showing a label above the numbers.
        Header: (
          <span
            style={{
              position: 'absolute',
              width: 1,
              height: 1,
              padding: 0,
              margin: -1,
              overflow: 'hidden',
              clip: 'rect(0,0,0,0)',
              whiteSpace: 'nowrap',
              border: 0,
            }}
          >
            {t`Rank`}
          </span>
        ),
      },
      {
        Cell: ({ original: { isCompleted, companyName, companyId, participants } }: CellInfo) => (
          <>
            {/*<Initials isCompleted={isCompleted} fullName={companyName || 'A'} />*/}
            {/*<Initials fullName={companyName || 'A'} />*/}
            <span id={companyId}>
              {companyName || anon}
              {/*<br />
              <small>
                {t`Participants`}: {participants}
              </small>*/}
            </span>
          </>
        ),
        Header: t`Name`,
        accessor: 'name',
      },
      {
        Cell: ({ original: { caloriesTotal, intensiveMinutesTotal, stepsTotal, percentage } }: CellInfo) => (
          <ProgressCell
            caloriesTotal={caloriesTotal}
            intensiveMinutesTotal={intensiveMinutesTotal}
            stepsTotal={stepsTotal}
            progress={parseInt(percentage)}
          />
        ),
        Header: t`Result`,
        accessor: 'percentage',
      },
    ]

    return (
      <>
        {/*<Card>
          <NotificationsWrapper />
          <YumHeader>
            <h1>{t`TOP 100`}</h1>
            {nonPublicCompanies.length > 1 && userCompaniesWithRanking.length ? (
              <YumSmallSelect variant="outlined" value={companyId} onChange={this.handleCompanyChange}>
                {userCompaniesWithRanking.map((userCompany: UserCompanyDto, keyIndex: number) => (
                  <option key={keyIndex} value={userCompany.companyId}>
                    {userCompany.companyName}
                  </option>
                ))}
              </YumSmallSelect>
            ) : (
              ''
            )}
            <YumSmallSelect value={month} onChange={this.handleMonthChange}>
              {this.state.monthsList.map((month: any, keyIndex: number) => (
                <option key={keyIndex} value={month.value}>
                  {month.label}
                </option>
              ))}
            </YumSmallSelect>
          </YumHeader>*/}

        <Grid container={true} justifyContent="space-between" alignContent="center" alignItems="center">
          {hasRoleInCompany(companyId, Role.ADMIN) ? (
            <Grid item style={{ marginRight: -12 }}>
              <Box display={'inline-block'}>
                <FormControlLabel
                  control={
                    <YumSwitch
                      color="secondary"
                      checked={this.props.companyIsExcludedFromRanking}
                      onChange={this.toggleCompanyExcludedFromRanking(companyId)}
                    />
                  }
                  label={<div style={isRtl ? { paddingRight: 10 } : { paddingLeft: 10 }}>{t`Anonymize`}</div>}
                  style={{ marginRight: 12, marginLeft: 1 }}
                />
              </Box>
              <Box
                display={'inline-block'}
                style={{
                  position: 'relative',
                  left: isRtl ? 0 : -12,
                  padding: isRtl ? '8px 12px 8px 0' : '8px 0 8px 12px',
                }}
              >
                <BlueTooltip
                  title={t`Turning on this switch will make your company anonymous to others.`}
                  placement="bottom-end"
                  enterTouchDelay={50}
                  leaveTouchDelay={3000}
                  arrow
                  PopperProps={{
                    container: document.getElementById('content'),
                  }}
                >
                  <InfoIcon />
                </BlueTooltip>
              </Box>
            </Grid>
          ) : (
            ''
          )}
        </Grid>

        <p style={{ marginTop: 0 }}>
          {t`Companies and communities in this table value health and physical activity. Here you can see their average activity level.`}{' '}
          <button
            role="link"
            type="button"
            className="activity-index-link link-blue"
            onClick={openActivityIndexArticle}
          >{t`What's activity index?`}</button>
        </p>

        {/*<Grid container={true} justifyContent="space-between" alignContent="center" alignItems="center">
            <Grid item={true}>
              <Legend
                symbol={<ProjectionSymbol />}
                description={t`Being above the line shows that you are on the track to complete the goal by the end of the period.`}
              />

              <Button
                className="button--with-bottom-margin"
                text={t`Find yourself`}
                onClick={this.findYourself}
                link={true}
                smaller={true}
                iconLeft={FingerPoint}
              />
            </Grid>
          </Grid>*/}

        <Table
          data={data}
          columns={columns}
          isLoading={companyRankingLoading}
          defaultSorted={[{ id: 'rank', desc: false }]}
          handleSortedChange={this.handleSortedChange}
          className="activity-list"
        />
        {/*</Card>*/}
      </>
    )
  }
}
